import classlist from 'utils/classlist';
import './style.scss';

export interface StickyBoxProps {
    containerClassName?: string;
    placement?: 'top' | 'bottom';
    children?: React.ReactNode;
}

const StickyBox: React.FC<StickyBoxProps> = props => {
    const { children, containerClassName, placement = 'bottom' } = props;

    return (
        <div
            className={classlist(
                'sticky-btn-root',
                {
                    'sticky-top': placement === 'top',
                    'sticky-bottom': placement === 'bottom'
                },
                containerClassName
            )}>
            {children}
        </div>
    );
};

export default StickyBox;
